<template>
  <section class="prizes-wrapper" id="prizes">
    <div class="content-w">
      <div class="content">
        <div class="page-title">
          <img src="@/assets/svg/prizes-title.svg" alt="Гарантированные призы" />
        </div>

        <div class="subtitle">Выиграй миллион призов для дачи</div>

        <div class="prizes-content-wrapper">
          <div class="prizes-tabs">
            <div class="prizes-tab-wrapper pointer-events-none">
              <div
                class="prizes-tab active pointer-events-none"
              >
                Гарантированный приз
              </div>
            </div>
          </div>

          <div class="prizes-cards-wrapper">
            <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/ivy.png" class="img" loading="lazy" />
              </div>
              <div class="prize-title">Подписка Иви</div>
              <div class="prize-text">
                На 45 дней, <br />
                сериалы и кино, <br />
                только для тебя
              </div>
            </div>
            <div class="prize-card">
              <div class="prize-img">
                <img src="@/assets/book.png" class="img" loading="lazy" />
              </div>
              <div class="prize-title smaller">
                Шашлычная книга <br />
                от Бочкарев
              </div>
              <div class="prize-text">
                Сам себе шеф, <br />
                секреты гриля от Бочкарев
              </div>
            </div>
          </div>

          <b-button
            class="promo-button button button-gold"
            variant="primary"
            @click="openModal()"
          >
            Введите код
          </b-button>
        </div>

        <div class="page-title page-title-2">
          <img src="@/assets/svg/prizes-title-2.svg" alt="Призы" />
        </div>

        <div class="prizes-content-wrapper">
          <div class="prizes-tabs">
            <div class="prizes-tab-wrapper border-right">
              <div
                class="prizes-tab"
                @click="mode = 'weekly'"
                :class="{ active: mode == 'weekly' }"
              >
                Еженедельные призы
              </div>
            </div>

            <div class="prizes-tab-wrapper border-right">
              <div
                class="prizes-tab"
                @click="mode = 'monthly'"
                :class="{ active: mode == 'monthly' }"
              >
                Ежемесячные призы
              </div>
            </div>

            <div class="prizes-tab-wrapper">
              <div
                class="prizes-tab"
                @click="mode = 'main'"
                :class="{ active: mode == 'main' }"
              >
                Главный приз
              </div>
            </div>
          </div>

          <div class="prev arrow-control" @click="changeToPrevMode()">
            <img src="@/assets/svg/arrow-left.svg" loading="lazy" />
          </div>

          <div class="next arrow-control" @click="changeToNextMode()">
            <img src="@/assets/svg/arrow-right.svg" loading="lazy" />
          </div>

            <div class="prizes-cards-wrapper">

              <transition name="slide" mode="out-in">
                <div class="prizes-content-transition-wrapper" v-show="mode === 'monthly'">
                  <div v-for="prize in monthlyPrizes.prizes" class="prize-card">
                    <div class="prize-img">
                      <img :src="prize.image" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title" v-html="prize.name">

                    </div>
                    <div class="prize-text" v-html="prize.sub_title">
                    </div>
                  </div>

                  <!-- <div class="prize-card">
                    <div class="prize-img">
                      <img src="@/assets/ozon-15.png" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title">
                      Сертификат OZON <br />
                      15 000 ₽
                    </div>
                    <div class="prize-text">
                      Уже вкуснее, можно <br />
                      и близких порадовать!
                    </div>
                  </div>

                  <div class="prize-card">
                    <div class="prize-img">
                      <img src="@/assets/jbl.png" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title">Колонка JBL</div>
                    <div class="prize-text">
                      Вкуснее только <br>
                      под приятную музыку <br>
                      и качественный звук!
                    </div>
                  </div> -->

                  <div class="main-prize-subtext">
                    {{ monthlyPrizes.description }}
                  </div>
                </div>
              </transition>

              <transition name="slide" mode="out-in">
                <div class="prizes-content-transition-wrapper" v-show="mode === 'weekly'">
                  <div v-for="prize in weeklyPrizes.prizes" class="prize-card">
                    <div class="prize-img">
                      <img :src="prize.image" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title" v-html="prize.name">

                    </div>
                    <div class="prize-text" v-html="prize.sub_title">
                    </div>
                  </div>

                  <!-- <div class="prize-card">
                    <div class="prize-img">
                      <img src="@/assets/ozon-3.png" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title">
                      Сертификат OZON <br>
                      3 000 ₽
                    </div>
                    <div class="prize-text">
                      На шампуры, угли <br>
                      или набор для барбекю
                    </div>
                  </div>

                  <div class="prize-card">
                    <div class="prize-img">
                      <img src="@/assets/grill-2.png" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title">Набор шампуров</div>
                    <div class="prize-text">
                      Для настоящего ценителя <br>
                      кулинарии и вкусовых <br>
                      сочетаний
                    </div>
                  </div> -->

                  <div class="main-prize-subtext" v-html="weeklyPrizes.description">
                  </div>
                </div>
              </transition>

              <transition name="slide" mode="out-in">
                <div class="prizes-content-transition-wrapper" v-show="mode === 'main'">
                  <div class="prize-card main">
                    <div class="prize-img main">
                      <img src="@/assets/bochkaryov.png" class="img" loading="lazy" />
                    </div>
                    <div class="prize-title">1 000 000  ₽ </div>
                    <div class="prize-text">
                      Без лишних слов. <br />
                      Идеальный приз!
                    </div>
                  </div>

                  <div class="main-prize-subtext">
                    02 сентября проводится розыгрыш главного приза
                  </div>
                </div>
              </transition>
            </div>

          <b-button
            class="promo-button button button-gold"
            variant="primary"
            @click="openModal()"
          >
            Введите код
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PrizesSection",

  data: () => ({
    mode: "weekly",
    timer: null,
    weeklyPrizes: {},
    monthlyPrizes: {},
  }),

  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  created() {
    this.timer = setInterval(this.startCarousel, 5500)
  },

  mounted() {
    this.getPrizes()
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    startCarousel() {
      if (this.mode == "weekly") {
        this.mode = "monthly"
      } else if (this.mode == "monthly") {
        this.mode = "main"
      } else if (this.mode == "main") {
        this.mode = "weekly"
      } else {

      }
    },

    changeToNextMode() {
      clearInterval(this.timer)

      if (this.mode == "weekly") {
        this.mode = "monthly"
      } else if (this.mode == "monthly") {
        this.mode = "main"
      } else if (this.mode == "main") {
        this.mode = "weekly"
      } else {

      }

      this.timer = setInterval(this.startCarousel, 5500)
    },

    changeToPrevMode() {
      clearInterval(this.timer)

      if (this.mode == "weekly") {
        this.mode = "main"
      } else if (this.mode == "monthly") {
        this.mode = "weekly"
      } else if (this.mode == "main") {
        this.mode = "monthly"
      } else {

      }

      this.timer = setInterval(this.startCarousel, 5500)
    },

    getPrizes() {
      this.$http.get("/reference/prizes").then((response) => {
        let res = response.data.data

        res.forEach(item => {
          if (item.type == "Еженедельные призы") {
            this.weeklyPrizes = item
          }

          if (item.type == "Ежемесячные призы") {
            this.monthlyPrizes = item
          }
        })
      })
    },

    openModal() {
      ym(108239013, "reachGoal", "cod_2");
      this.$bvModal.show('promo-end-modal')
      // if (this.user) {
      //   this.$bvModal.show("enter-code-modal");
      // } else {
      //   this.$bvModal.show("login-modal");
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.prizes-wrapper {
  z-index: 999;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 150px;

  @media (max-width: 1440px) {
  }

  @media (max-width: 1300px) {
    background-size: 94%;
  }

  @media (max-width: 1270px) {
    background-image: none;
  }

  @media(max-width: 768px) {
    padding-bottom: 70px;
  }
}

.page-title {
  z-index: 99;
  position: relative;

  img {
    width: 160px;
    margin-bottom: 20px;
    z-index: 99;
    position: relative;
  }
}

.page-title-2 {
  margin-top: 127px;
  margin-bottom: 40px;

  @media(max-width: 678px) {
    margin-top: 70px;
    margin-bottom: 20px;
  }

  img {
    max-width: 1100px;
    margin-bottom: 20px;
    width: 97%;
  }
}

.content-w {
  @media (max-width: 1400px) {
    max-width: 1128px;
  }
  @media (max-width: 1250px) {
    max-width: 855px;
  }
}

.subtitle {
  color: white;
  font-size: 26px;
  font-family: $regular;
  margin-bottom: 57px;

  @media (max-width: 678px) {
    font-size: 16px;
    margin-bottom: 20px;
  }
}

.subtitle-bottom {
  color: white;
  font-size: 22px;
  font-family: $regular;
  margin-top: 30px;
  font-weight: 600;

  @media (max-width: 678px) {
    font-size: 16px;
    margin-top: 20px;
  }
}

.prizes-content-wrapper {
  width: 100%;
  position: relative;
}

.prizes-tabs {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 60px;
  padding-left: 36px;
  padding-right: 36px;
  padding-top: 17px;
  padding-bottom: 17px;
  justify-content: space-between;

  @media (max-width: 1200px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 678px) {
    background-color: transparent;
    flex-wrap: wrap;
    padding: 0;
  }
}

.prizes-tab-wrapper {
  background-color: white;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;

  @media (max-width: 678px) {
    width: 49%;
    height: 29px;
    margin-bottom: 8px;

    &:last-child {
      width: 100%;
    }
  }
}

.prizes-tab {
  cursor: pointer;
  border-right: 1px solid #004a0b;
  width: 100%;
  height: 100%;
  font-size: 18px;
  font-weight: 600;
  transition: 0.8s all;

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 678px) {
    background-color: white !important;
    border-radius: 20px;
    font-size: 12px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:last-child {
    border-right: none;
  }

  &:hover {
    opacity: 0.7;
  }

  &.active {
    background: linear-gradient(90deg, #b37427 0%, #ffd19a 50%, #b37427 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent; /* Fallback */
    pointer-events: none;
  }
}

.prizes-cards-wrapper {
  margin-top: 19px;
  width: 100%;
  display: flex;
  border-radius: 20px;
  padding-top: 70px;
  padding-bottom: 130px;
  background-image: url("../assets/prizes-bg.png");
  background-color: transparent;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: center;
  position: relative;
  height: 560px;
  overflow: hidden;

  @media (max-width: 1200px) {
    height: 431px;
    padding-top: 45px;
  }

  @media (max-width: 678px) {
    height: 400px;
    border-radius: 0;
    width: 100vw;
    margin-left: -10px;
    padding-top: 35px;
  }
}

.prize-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 265px;
  margin-left: 6px;
  margin-right: 7px;
  height: fit-content;

  @media (max-width: 1200px) {
    max-width: 200px;
  }

  &.main {
    max-width: 395px;
  }
}

.main-prize-subtext {
  position: absolute;
  bottom: 65px;
  font-size: 14px;
  color: #b4722d;

  @media (max-width: 1200px) {
    bottom: 45px;
  }

  @media (max-width: 678px) {
    font-size: 12px;
    max-width: 90%;
    line-height: 106%;
  }
}

.prize-img {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: linear-gradient(180deg, #00712f 0%, #093b1f 129.68%);
  padding: 25px;
  margin-bottom: 30px;
  height: 236px;

  @media (max-width: 1200px) {
    height: 185px;
    max-width: 200px;
    margin-bottom: 15px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  @media (max-width: 678px) {
    max-width: 175px;
    height: 162px;

    img {
      height: auto;
    }

    &.main {
      max-width: 300px;
    }
  }

  img {
    width: 100%;
  }

  &.main {
    background: transparent;
  }
}

.arrow-control {
  position: absolute;
  bottom: 50%;
  top: 50%;
  z-index: 999999;
  cursor: pointer;
  transition: 0.6s all;

  @media (max-width: 678px) {
    display: none;
  }

  &:hover {
    opacity: 0.7;
  }
}

.prev {
  left: -2.5%;
  transform: translate(-50%, -50%);

  &:hover {
    opacity: 0.7;
  }
}

.next {
  right: -2.5%;
  transform: translate(50%, -50%);
}

.prize-title {
  color: #b4722d;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 120%;

  &.smaller {
    margin-top: -12px;
  }

  @media (max-width: 1200px) {
    font-size: 18px;
  }

  @media (max-width: 678px) {
    font-size: 16px;
    line-height: 110%;

    &.smaller {
      margin-top: -6px;
    }
  }
}

.prize-text {
  color: #4e4e4e;
  font-size: 18px;
  font-weight: 400;
  line-height: 120%;

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 678px) {
    font-size: 13px;
  }
}

.button {
  font-weight: 600;
  font-size: 18px;
  width: 100%;
  margin-top: 28px;
  max-width: 354px;

  @media (max-width: 678px) {
    height: 39px;
  }
}

.border-right {
  border-right: 1px solid black !important;
  border-radius: 0 !important;

  @media(max-width: 678px) {
    border-color: transparent !important;
    border-radius: 20px !important;
  }
}

.prizes-content-transition-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  overflow: hidden;
  padding-top: 70px;

  @media (max-width: 1200px) {
    padding-top: 45px;
  }

  @media (max-width: 678px) {
    padding-top: 35px;
  }
}
</style>
